<template>
  <div class="row">
    <div class="col-lg-12">
      <loading
        loader="dots"
        :height="170"
        :width="170"
        color="#3282b8"
        background-color="#505273"
        transition="fade"
        :active="isLoading"
        :is-full-page="true"
      ></loading>

      <div class="row">
        <div class="col-lg-7 inline">
          <h4>
            <h2 style="display: inline">Analytics | &nbsp;</h2>
            Select Interval:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.time"
              @change="getDatas()"
            >
              <el-option
                v-for="option in selects.times"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col-lg-5 style-date">
          <span class="demonstration">Select Date Range</span>
          <el-date-picker
            v-model="selects.date"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="getDatas()"
          ></el-date-picker>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <h4>
            Select Site:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.site"
              @change="getDatas()"
            >
              <el-option
                v-for="option in selects.sites"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col-lg-4">
          <h4>
            Select Line:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.line"
              @change="getDatas()"
            >
              <el-option
                v-for="option in selects.lines"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>

        <div class="col-lg-4">
          <h4>
            Select Instruments:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.instrument"
            >
              <el-option
                v-for="option in selects.instruments"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12" v-for="(item, index) in dataarray" :key="index">
          <card type="card-chart">
            <template slot="header">
              <h5 class="card-category">
                <b>{{ graphtitle }}</b>
              </h5>
              <h3 class="card-title">
                <i class="tim-icons icon-chart-bar-32 text-info"></i>
                <b>&nbsp;{{ item.measure }}</b>
              </h3>
            </template>

            <div class="chart-area">
              <bar-chart
                v-if="item.loaded"
                :chart-data="item.chartData"
                :extra-options="item.extraOptions"
                :gradient-colors="item.gradientColors"
                :gradient-stops="item.gradientStops"
                :height="245"
              ></bar-chart>
              <div
                class="d-flex justify-content-center spinner"
                v-if="!item.loaded"
              >
                <circle-8></circle-8>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import { Select, Option, DatePicker } from "element-ui";

import axios from "axios";
import moment from "moment";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import { time } from "d3";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    LineChart,
    BarChart,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    Circle8,
    Loading,
  },
  data() {
    return {
      dataarray: [],
      isLoading: false,
      graphtitle: "",

      start: "",
      end: "",

      instrumentID: "",
      incineratorID: "",
      title: "",

      color: ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
		  '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
		  '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
		  '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
		  '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', 
		  '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
		  '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', 
		  '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
		  '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
		  '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'],

      selects: {
        totalgraph: 0,
        date: [],
        site: "",
        sites: [],
        time: "daily",
        times: [
          { value: "daily", label: "Daily" },
          { value: "weekly", label: "Weekly" },
          { value: "monthly", label: "Monthly" },
          { value: "yearly", label: "Yearly" },
        ],
        line: "",
        lines: [],
        instrument: "",
        instruments: [],
      },

      frequency: {
        chartData: {
          labels: ["date 1", "date 2"],

          datasets: [
            {
              label: "jenis sensor",
              fill: true,
              borderColor: "#641E16",
              backgroundColor: "#641E16",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [
                80 /* data date 1 */, 70 /* data date 2 */, 90, 85, 75, 81, 69,
              ],
            },
            {
              label: "jenis sensor",
              fill: true,
              borderColor: "#512E5F",
              backgroundColor: "#512E5F",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      pressure: {
        chartData: {
          labels: ["Work Type 1", "Work Type 2"],

          datasets: [
            {
              label: "Breakdown",
              fill: true,
              borderColor: "#641E16",
              backgroundColor: "#641E16",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Corrective",
              fill: true,
              borderColor: "#512E5F",
              backgroundColor: "#512E5F",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      temperature: {
        chartData: {
          labels: ["Work Type 1", "Work Type 2"],

          datasets: [
            {
              label: "Breakdown",
              fill: true,
              borderColor: "#641E16",
              backgroundColor: "#641E16",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
            {
              label: "Corrective",
              fill: true,
              borderColor: "#512E5F",
              backgroundColor: "#512E5F",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },
    };
  },

  methods: {
    getDatas() {
      this.isLoading = true;

      console.log("a : ", this.selects.time);
      console.log("b : ", this.selects.date);
      console.log("c : ", this.selects.site);
      console.log("d : ", this.selects.line);
      console.log("e : ", this.selects.instrument);
      
      if (
        this.selects.time != "" &&
        this.selects.date.length != 0 &&
        this.selects.site != "" &&
        this.selects.line != "" &&
        this.selects.instrument != ""
      ) {
        let url = "";
        let start = moment(this.selects.date[0]).format("YYYY-MM-DD");
        let end = moment(this.selects.date[1]).format("YYYY-MM-DD");

        // if (this.selects.time == "daily" || this.selects.time == "yearly") {
        //   url =
        //     ":9999/api/v1/incinerator/data/" +
        //     this.selects.time +
        //     "?from=" +
        //     start +
        //     "&destination_code=" +
        //     this.selects.site +
        //     "&incinerator_id=" +
        //     this.selects.line +
        //     "&instrument_id=" +
        //     this.selects.instrument;
        // } else {
          url =
            ":9999/api/v1/incinerator/data/" +
            this.selects.time +
            "?from=" +
            start +
            "&to=" +
            end +
            "&destination_code=" +
            this.selects.site +
            "&incinerator_id=" +
            this.selects.line +
            "&instrument_id=" +
            this.selects.instrument;
        // }

        this.dataarray = [];
        console.log("baru pgl api");

        this.$http.get(url).then((res) => {
          if (!res.error) {
            console.log(res.message);
            let response = res.message[0].Instruments[0].measurement;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              let clusterdata = [];
              let wholegraph = {};
              let timestamp = [];
              for (var j = 0; j < response[i].sensors.length; j++) {
                console.log(response[i].sensors[j].label);
                let data = [];

                let dataset = {};
                for (
                  var k = 0;
                  k < response[i].sensors[j].sensor_values.length;
                  k++
                ) {
                  
                  // just to store 1st index of timestamp
                  if (j == 0) {
                    // check interval to decide how x-axis looks like
                    if(this.selects.time == 'daily'){
                      timestamp.push(
                        moment(
                          response[i].sensors[j].sensor_values[k].read_at
                        ).format("YYYY-MM-DD")
                      );
                    }

                    if(this.selects.time == 'weekly'){
                      timestamp.push(response[i].sensors[j].sensor_values[k].read_at);
                    }

                    if(this.selects.time == 'monthly'){
                      timestamp.push(moment(response[i].sensors[j].sensor_values[k].read_at, "MMM").format("MMM"));
                    }

                    if(this.selects.time == 'yearly'){
                      timestamp.push(response[i].sensors[j].sensor_values[k].read_at);
                    }

                    
                  }

                 
                  data.push(response[i].sensors[j].sensor_values[k].value);
                }
                dataset = {
                  label: response[i].sensors[j].label,
                  fill: true,
                  borderColor: this.color[j],
                  backgroundColor: this.color[j],
                  borderWidth: 2,
                  borderDash: [],
                  borderDashOffset: 0.0,
                  data: data,
                };

                clusterdata.push(dataset);
              }

              console.log(timestamp);

              wholegraph = {
                measure: response[i].measure,
                chartData: {
                  labels: timestamp,
                  datasets: clusterdata,
                },
                loaded: true,
                extraOptions: chartConfigs.barChartOptionsGradient,
                gradientColors: [
                  "rgba(255, 3, 2, 0.8)",
                  "rgba(255, 3, 2, 0.2)",
                  "rgba(255, 3, 2, 0.1)",
                ],
                gradientStops: [1, 0],
              };

              this.dataarray.push(wholegraph);
            }
          }
        });
        this.isLoading = false;
      } else {
        console.log("jgn pgl");
      }
    },

    getInstrument() {
      console.log("get instrument");
      this.selects.instruments = [];

      this.$http
        .get(
          ":9999/api/v1/setting/instrument?destination_code=" +
            this.selects.site +
            "&incinerator_id=" +
            this.selects.line
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].instrument_name,
                value: response[i].instrument_id,
              };

              this.selects.instruments.push(obj);
            }

            //ini untuk set default
            this.selects.instrument = this.selects.instruments[0].value;
          }
        });
    },

    getLines() {
      console.log("getlines");
      this.selects.lines = [];

      this.$http
        .get(
          ":9999/api/v1/setting/incinerator?destination_code=" +
            this.selects.site
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            for (var i = 0; i < response.length; i++) {
              let obj = {
                value: response[i].incinerator_id,
                label: response[i].incinerator_code,
              };

              this.selects.lines.push(obj);
            }

            //ini untuk set default
            this.selects.line = this.selects.lines[0].value;
          }
        });
    },

    getSite() {
      this.selects.sites = [];

      this.$http.get(":9999/api/v1/setting/destination").then((res) => {
        if (!res.error) {
          let response = res.message;

          //destination_id ganti destination_name
          for (var i = 0; i < response.length; i++) {
            let obj = {
              value: response[i].destination_code,
              label: response[i].destination_name,
            };

            this.selects.sites.push(obj);
          }

          //ini untuk set default
          this.selects.site = this.selects.sites[0].value;
        }
      });
    },
  },
  created() {
    this.selects.date = [ moment().startOf('M'), moment()]
    this.getSite();
  },
  mounted() {},

  //ini untuk jalankan methods if anything selected
  watch: {
    "selects.site"() {
      this.getLines();
    },

    "selects.line"() {
      this.getInstrument();
    },
    "selects.instrument"() {
      this.getDatas();

      for (var i = 0; i < this.selects.instruments.length; i++) {
        if (this.selects.instrument == this.selects.instruments[i].value) {
          this.graphtitle = this.selects.instruments[i].label;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
}
hr {
  color: black;
  margin-top: 0%;
}
.select-width {
  max-width: 50%;
}
.spinner {
  margin: 12%;
}
</style>
